module.exports = __webpack_public_path__ + "static/media/paint4.8a2404d2.jpg";